import React, { useEffect, useMemo, useState } from 'react';
import { safeHTML } from '../../../utils/safeHTML';
import { nyTaskContent } from '../../../constants/copyright';
import NyTaskSection from './NyTaskSection';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import AppLoader from '../../features/appLoader/AppLoader';
import QuizComponent from '../quiz/quizComponent/QuizComponent';
import { CSSTransition } from 'react-transition-group';
import { useQuizComponents } from '../../../hooks/useQuizComponents';
import { useContent, setInitialNyTaskActiveUid } from '../../../redux/reducer/content';
import { useNyTaskRequestHandler } from '../../../hooks/useNyTaskRequestHandler';
import { useNyTaskCallbacks } from '../../../hooks/useNyTaskCallbacks';
import { useRequests } from '../../../redux/reducer/requests';
import { useDispatch } from 'react-redux';
import { useTranslation } from '../../../translations';
import { getCurrentWeekTitle } from '../../../utils/getCurrentWeekTitle';
import { convertDateFormat } from '../../../utils/helpers/helpers';

const { buttonsList, winners } = nyTaskContent;

const NyTask = React.forwardRef(function NyTask({ callbacks }, ref) {
  const {
    quizQuests: { quizQuests, activeQuiz },
    initialNyTaskActiveUid,
  } = useContent();
  const { authData: { isWeb } = {} } = useRequests() || {};
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const [activeItem, setActiveItem] = useState(0);
  const [buttonId, setButtonId] = useState('');
  const [quizScore, setQuizScore] = useState([]);

  const isArrayAndNotEmpty = (value) => Array.isArray(value) && value.length > 0;

  const filteredQuizQuests = useMemo(() => {
    return isArrayAndNotEmpty(quizQuests)
      ? quizQuests.filter((quest) => {
          const hasValidPrizes = quest.prizes !== null && isArrayAndNotEmpty(quest.prizes);
          return !quest.title.includes('_hiddenObject') || hasValidPrizes;
        })
      : [];
  }, [quizQuests]);

  const title = useMemo(() => getCurrentWeekTitle(filteredQuizQuests), [filteredQuizQuests]);
  const formattedTitle = useMemo(() => convertDateFormat(title, i18n.language), [title, i18n.language]);

  const { reset, setActive, setScore, pause, nextStep, openQuizModal, buttonClick, getQuestTaskState } =
    useNyTaskCallbacks({ callbacks, setQuizScore, setActiveItem, setButtonId, activeItem });

  const quizComponent = useQuizComponents({
    currentQuiz: activeQuiz,
    activeItem,
    setScore,
    nextStep,
    buttonId,
    setButtonId,
    isNY: true,
  });

  const isPending = useNyTaskRequestHandler({
    setQuizScore,
    setActiveItem,
    setButtonId,
    quizScore,
    callbacks,
    reset,
  });

  // чтобы не показывать модалки при открытии страницы
  // useNyInfoModals();

  useEffect(() => () => setActive('offAll'), []);

  useEffect(() => {
    if (initialNyTaskActiveUid && isArrayAndNotEmpty(filteredQuizQuests)) {
      let targetUid = null;
      if (initialNyTaskActiveUid === 'first') {
        targetUid = filteredQuizQuests[0]?.uid;
      } else {
        targetUid = initialNyTaskActiveUid;
      }

      if (targetUid) {
        setActive(targetUid);
        dispatch(setInitialNyTaskActiveUid(null));
      }
    }
  }, [initialNyTaskActiveUid, filteredQuizQuests, setActive, dispatch]);

  return (
    <section className={`ny-task ${isWeb ? '' : 'app'}`} ref={ref}>
      {/*<div className={`ny-task__background screen-bg`}/>*/}
      <div className={`ny-task__header ${isWeb ? '' : 'app'}`}>
        <h1 className={'ny-task__title'}>
          {safeHTML(t('other.week'))}
          <span>{safeHTML(formattedTitle)}</span>
        </h1>
      </div>
      <div className={'ny-task__content'}>
        {/* <div className={"ny-task__note"}>
            <img className={"ny-task__note-image"} src={note.img} alt={"info-img"}/>
            <div className={"ny-task__note-text"}>{safeHTML(t(note.text))}</div>
          </div>*/}
        <ul className={'ny-task__list'}>
          {filteredQuizQuests.map((item, index) => (
            <NyTaskSection
              callbacks={callbacks}
              key={`task-item-${index}`}
              item={item}
              activeCondition={item.isActive}
              onClick={() => setActive(item.uid)}
              openQuizModal={openQuizModal}
              getQuestTaskState={getQuestTaskState}
              winners={{ ...winners, list: item?.winners, title: item?.title }}
            />
          ))}
        </ul>
      </div>
      <div className={'ny-task__buttons'}>
        {buttonsList.map(({ className, text, action, ...props }, index) => (
          <CustomButton
            {...props}
            key={`TasksBtn-${index}`}
            className={className}
            text={text}
            onClick={() => buttonClick(action)}
          />
        ))}
      </div>
      <CSSTransition in={!!activeQuiz} classNames={'ny-task__quiz'} timeout={700} unmountOnExit={true}>
        <div className={'ny-task__quiz'}>
          <QuizComponent activeItem={activeItem} pause={pause} component={quizComponent} currentQuiz={activeQuiz} />
        </div>
      </CSSTransition>
      {isPending && <AppLoader />}
    </section>
  );
});

export default NyTask;
NyTask.propTypes = {};
